<template>
  <div v-editable="blok" :class="classes">
    <div v-if="basket" class="shopify-cart">
      <h1>{{ blok.title }}</h1>
      <div class="shopify-cart-item" :key="index" v-for="(item,index) in basket.lineItems">
        <div class="image">
          <img :src="item.variant.image.src" width="200">
        </div>
        <div class="name">{{ item.title }}</div>
        <div class="price">
          <span v-mny="{ input: item.variant.price, currency: basket.currencyCode }"></span>
        </div>
        <div class="actions">
          <product-cta-button
            :productId="item.variant.id"
            @descreaseBasketItem="descreaseBasketItem"
            @increaseBasketItem="increaseBasketItem"
            @addToBasket="addProductToBasket(product,index)"
          ></product-cta-button>
        </div>
        <div class="price total-price">
          <span
            v-mny="{ input: (item.variant.price * item.quantity), currency: basket.currencyCode }"
          ></span>
        </div>
      </div>
    </div>
    <div class="shopify-cart-summary">
      <div class="shopify-summary-price">
        <span
          v-mny="{ input: basket ? basket.paymentDue : 0, currency: basket ? basket.currencyCode : 0 }"
        ></span>
      </div>
      <shopify-delivery-note></shopify-delivery-note>
      <div class="shopify-summary-shipping" v-if="basket && basket.shippingLine">
        (
        <span v-mny="{ input: basket.shippingLine.price, currency: basket.currencyCode }"></span>)
      </div>
      <div class="shopify-cart-button" v-if="basket">
        <div style="padding-right:0 !important; color: red" v-if="deliveryNotes==''">
          <b>Please enter your delivery instructions first.</b>
        </div>
        <a class="cta-button" @click="onProceed()" :href="basketUrl">
          <span>
            <span>{{ blok.checkout_link_label }}</span>
          </span>
        </a>
      </div>
      <div class="shopify-clear-cart-button" v-if="basket">
        <button class="cta-button" @click="onClearCart()">
          <span>
            <span>Clear Cart</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ProductCtaButton from "./ProductCtaButton";
import ShopifyDeliveryNote from "./ShopifyDeliveryNote";

export default {
  name: "shopify-basket",
  components: {
    ProductCtaButton,
    ShopifyDeliveryNote
  },
  props: {
    blok: Object
  },
  methods: {
    ...mapActions("shopify", [
      "getAllProducts",
      "addProductToShopifyCart",
      "removeProductFromShopifyCart",
      "descreaseBasketItem",
      "increaseBasketItem",
      "clearCart"
    ]),
    ...mapActions("configuration", ["getValue"]),
    ...mapActions("analytics", ["trackClearCart","trackCheckoutProgress"]),
    onAddProductToBasket: function(product, index = 0) {
      this.addProductToShopifyCart(product);
    },
    onRemoveVariantFromBasket: function(lineItem) {
      this.removeProductFromShopifyCart(lineItem);
    },
    onClearCart: function() {
      this.trackClearCart(this.basket.lineItems.map( lineItem => {
        return {
          "id": lineItem.id,
          "name": lineItem.title,
          "list_name": lineItem.title,
          "category": lineItem.productType,
          "variant": lineItem.variant.sku,
          "price": lineItem.variant.price  
        }
      }));
      this.clearCart();
    },
    onProceed: function() {
      if(this.deliveryNotes&&this.deliveryNotes!='') {
        this.trackCheckoutProgress(this.basket.lineItems.map( lineItem => {
          return {
            "id": lineItem.id,
            "name": lineItem.title,
            "list_name": lineItem.title,
            "category": lineItem.productType,
            "variant": lineItem.variant.sku,
            "price": lineItem.variant.price,
            "quantity": lineItem.quantity
          }
        }));
      }
    }
  },
  computed: {
    ...mapState({
      basket: state => state.shopify.checkout,
      primaryShopifyDomain(state) {
        return state.configuration.values.get("primaryShopifyDomain");
      },
      defaultShopifyDomain(state) {
        return state.configuration.values.get("defaultShopifyDomain");
      }
    }),
    deliveryNotes: {
        get() {
            if(this.basket){
                const notes = this.basket.customAttributes.find((v)=>{
                    return v.key == 'delivery_instructions';
                })
                return notes ? notes.value : '';
            }
            return '';
        }
    },
    classes: function() {
      const b = this.$props.blok;
      return [
        "blok shopify-basket",
        b.contain ? "contained" : "",
        this.$props.blok.classes
      ];
    },
    basketUrl: function() {
      const basketUrl = this.basket.webUrl;
      if(this.deliveryNotes&&this.deliveryNotes!='') {
        return basketUrl.replace(
          this.defaultShopifyDomain,
          this.primaryShopifyDomain
        );
      }
      return 'javascript://'
    }
  }
};
</script>
